import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7bce6faa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "topbar"
};
const _hoisted_2 = {
  class: "header-filters",
  gap: 28
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "Customer Insights", -1));
const _hoisted_4 = {
  class: "toolbar"
};
const _hoisted_5 = {
  class: "navigation-wrapper"
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_customer_insights_filters = _resolveComponent("customer-insights-filters");
  const _component_currency_filter = _resolveComponent("currency-filter");
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_period_controllers = _resolveComponent("period-controllers");
  const _component_performance_period_table = _resolveComponent("performance-period-table");
  const _component_l_t_v_period_controller = _resolveComponent("l-t-v-period-controller");
  const _component_l_t_v_period_table = _resolveComponent("l-t-v-period-table");
  const _component_l_t_v_per_asin_controller = _resolveComponent("l-t-v-per-asin-controller");
  const _component_l_t_v_per_asin_table = _resolveComponent("l-t-v-per-asin-table");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    "content-padding": "0",
    class: "customer-insights"
  }, {
    topbar: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_customer_insights_filters)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_currency_filter, {
      currencies: _ctx.currencies,
      "only-mode": "",
      onApply: $options.handleApplyForCurrencyChange
    }, null, 8, ["currencies", "onApply"])])])]),
    "topbar-sub": _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_navigation_tabs, {
      tabs: $options.computedTabs,
      modelValue: $options.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.tab = $event)
    }, null, 8, ["tabs", "modelValue"])])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["customer-insights-contents", [_ctx.floatingTableState]])
    }, [_createVNode(_component_flex_column, {
      gap: 24,
      classes: "all-wrapper"
    }, {
      default: _withCtx(() => [_ctx.currentTabValue === 'dashboard' ? (_openBlock(), _createBlock(_component_performance_period_table, {
        key: 0,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[3] || (_cache[3] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[1] || (_cache[1] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[2] || (_cache[2] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: $options.computedPeriodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", null, [_ctx.currentTabValue === 'ltv' ? (_openBlock(), _createBlock(_component_l_t_v_period_table, {
        key: 0,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[8] || (_cache[8] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[4] || (_cache[4] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[5] || (_cache[5] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: $options.computedPeriodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"]), _createVNode(_component_l_t_v_period_controller, {
          ltv: $options.ltv,
          "onUpdate:ltv": _cache[6] || (_cache[6] = $event => $options.ltv = $event),
          ltvOffset: $options.ltvOffset,
          "onUpdate:ltvOffset": _cache[7] || (_cache[7] = $event => $options.ltvOffset = $event),
          ltvSelectorOptions: _ctx.ltvSelectorOptions,
          ltvOffsetOptions: _ctx.ltvOffsetOptions
        }, null, 8, ["ltv", "ltvOffset", "ltvSelectorOptions", "ltvOffsetOptions"])])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'ltv_per_asin' ? (_openBlock(), _createBlock(_component_l_t_v_per_asin_table, {
        key: 1,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[9] || (_cache[9] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_l_t_v_per_asin_controller)]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true)], 512), [[_vShow, _ctx.isOmnyAdmin || _ctx.isOmnyUser]])]),
      _: 1
    })], 2)]),
    _: 1
  });
}